import React from "react";

// Icone a linea sottile (Lucide), come nel design system SURVMAPS.
const PATHS = {
  search: ['<circle cx="11" cy="11" r="8"/>', '<path d="m21 21-4.3-4.3"/>'],
  x: ['<path d="M18 6 6 18"/>', '<path d="m6 6 12 12"/>'],
  crosshair: ['<circle cx="12" cy="12" r="10"/>', '<line x1="22" x2="18" y1="12" y2="12"/>', '<line x1="6" x2="2" y1="12" y2="12"/>', '<line x1="12" x2="12" y1="6" y2="2"/>', '<line x1="12" x2="12" y1="22" y2="18"/>'],
  layers: ['<path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/>', '<path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/>', '<path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>'],
  pencil: ['<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/>', '<path d="m15 5 4 4"/>'],
  square: ['<rect width="18" height="18" x="3" y="3" rx="2"/>'],
  "file-text": ['<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/>', '<path d="M14 2v4a2 2 0 0 0 2 2h4"/>', '<path d="M10 9H8"/>', '<path d="M16 13H8"/>', '<path d="M16 17H8"/>'],
  download: ['<path d="M12 15V3"/>', '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>', '<path d="m7 10 5 5 5-5"/>'],
  "chevron-down": ['<path d="m6 9 6 6 6-6"/>'],
  "arrow-right": ['<path d="M5 12h14"/>', '<path d="m12 5 7 7-7 7"/>'],
  check: ['<path d="M20 6 9 17l-5-5"/>'],
  trash: ['<path d="M3 6h18"/>', '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>'],
  ruler: ['<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/>', '<path d="m14.5 12.5 2-2"/>', '<path d="m11.5 9.5 2-2"/>', '<path d="m8.5 6.5 2-2"/>', '<path d="m17.5 15.5 2-2"/>'],
  lock: ['<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>', '<path d="M7 11V7a5 5 0 0 1 10 0v4"/>'],
  user: ['<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>', '<circle cx="12" cy="7" r="4"/>'],
  "external-link": ['<path d="M15 3h6v6"/>', '<path d="M10 14 21 3"/>', '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>'],
  eye: ['<path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>', '<circle cx="12" cy="12" r="3"/>'],
  map: ['<path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"/>', '<path d="M15 5.764v15"/>', '<path d="M9 3.236v15"/>'],
  grid: ['<rect width="18" height="18" x="3" y="3" rx="2"/>', '<path d="M3 9h18"/>', '<path d="M3 15h18"/>', '<path d="M9 3v18"/>', '<path d="M15 3v18"/>'],
  polygon: ['<path d="M12 3 21 9.5 17.5 20h-11L3 9.5z"/>'],
};

export default function Icon({ name, size = 18, style }) {
  const paths = PATHS[name];
  if (!paths) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: paths.join("") }}
    />
  );
}
